export const formatPascalCase = (str: string): string => {
  const lowerStr = str.toLowerCase();
  const words = lowerStr.split(/[^a-z0-9]+/).filter(Boolean);
  const pascalCase = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join('');
  return pascalCase;
};
